import { render, staticRenderFns } from "./replyDialog.vue?vue&type=template&id=b6bc837c&scoped=true&"
import script from "./replyDialog.vue?vue&type=script&lang=js&"
export * from "./replyDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6bc837c",
  null
  
)

export default component.exports